import { useIntl } from 'react-intl';

import imagoPinkWhite from 'src/assets/imagoPinkWhite.svg';

import { i18n } from './Logo.i18n';
import { useStyles } from './Logo.styles';

const Logo = () => {
    const intl = useIntl();
    const { classes } = useStyles();
    return (
        <img src={imagoPinkWhite} className={classes.logo} alt={intl.formatMessage(i18n.logoAlt)} />
    );
};

export default Logo;
